export const filterOutNumericKeys = (obj: Record<string, any>) => {
  return Object.keys(obj).filter(key => !(Number(key) >= 0));
};
